module.exports = __webpack_public_path__ + "media/components/home/sign-up-free/img/sign-up-free-mobile-18b5e43254aa2e23f5907b3ae4abee6f.jpg";